import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// import slide_img_new1 from '../assets/images/what_makes_us_ different/level_playing_field.png';
import slide_img_new2 from "../assets/images/what_makes_us_ different/track_your_triumphs.jpg";
// import slide_img_new3 from '../assets/images/slide_img_new3.png';
// import slide_img_new4 from '../assets/images/what_makes_us_ different/accurate_scoring.jpg';
// import slide_img_new5 from '../assets/images/what_makes_us_ different/every_match_counts.jpg';
import slide_img_new6 from "../assets/images/what_makes_us_ different/play_in_style.jpg";

import slide_img_new1 from "../assets/images/what_makes_us_ different/all_skill_levels_welcome.jpg";
import slide_img_new4 from "../assets/images/what_makes_us_ different/fair_play_fun_filled_matches.jpg";
import slide_img_new3 from "../assets/images/what_makes_us_ different/community_driven_competition.jpg";
import slide_img_new5 from "../assets/images/what_makes_us_ different/great_venues_great_vibes.jpg";

const MyCarousel = () => {
  const options = {
    dots: false,
    center: true,
    items: 3,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    loop: true,
    margin: 10,
    responsiveClass: true,
    nav: true,
    navText: ["<", ">"],
    smartSpeed: 500,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      600: {
        items: 3,
        nav: true,
      },
      1000: {
        items: 3,
        nav: true,
      },
    },
  };

  return (
    <div>
      <OwlCarousel
        className=" owl-carousel owl-theme cpl-carousel"
        {...options}
      >
        <div className="item">
          <div className="slider_card">
            <div className="slider_img_div">
              <img src={slide_img_new1} alt="img" />
            </div>
            <div className="slider_content">
              {/* <div className='content_div_heading'>Level Playing Field</div>
              <div className='content_div_text'>
                We ensure a level playing field with equal representation from
                every suburb, giving everyone a shot at glory!
              </div> */}
              <div className="content_div_heading">
                Grassroots-Friendly Tournament{" "}
              </div>
              <div className="content_div_text">
                Whether you are just starting out, looking to build confidence
                or simply play for fun, there’s a spot for you!
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="slider_card">
            <div className="slider_img_div">
              <img src={slide_img_new3} alt="img" />
            </div>
            <div className="slider_content">
              {/* <div className='content_div_heading'>
                Built on Professionalism
              </div>
              <div className='content_div_text'>
                Experience a tournament run with the highest standards of
                professionalism, where every game celebrates the community and
                competitive spirit!
              </div> */}
              <div className="content_div_heading">Community-Driven Event</div>
              <div className="content_div_text">
                Represent your suburb and be part of an event that celebrates
                local spirit and camaraderie!
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="slider_card">
            <div className="slider_img_div">
              <img src={slide_img_new2} alt="img" />
            </div>
            <div className="slider_content">
              {/* <div className='content_div_heading'> Track Your Triumphs</div>
              <div className='content_div_text'>
                Stay ahead with our awesome web app, designed to help you
                monitor your stats like a pro and track your growth throughout
                the tournament!
              </div> */}
              <div className="content_div_heading"> Track Your Progress </div>
              <div className="content_div_text">
                Use our easy-to-access web app to see your match results and
                personal milestones!
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="slider_card">
            <div className="slider_img_div">
              <img src={slide_img_new4} alt="img" />
            </div>
            <div className="slider_content">
              {/* <div className='content_div_heading'> Accurate Scoring</div>
              <div className='content_div_text'>
                Enjoy the confidence of fair play with precise scoring for every
                match, ensuring a tournament that leaves you fulfilled!
              </div> */}
              <div className="content_div_heading">
                {" "}
                Fair Play & Fun-Filled Matches{" "}
              </div>
              <div className="content_div_text">
                Every game is played in a positive, well-managed setting that
                ensures an enjoyable experience for all!
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="slider_card">
            <div className="slider_img_div">
              <img src={slide_img_new5} alt="img" />
            </div>
            <div className="slider_content">
              {/* <div className='content_div_heading'> Every Match Counts</div>
              <div className='content_div_text'>
                Our points system ensures that every strong performance you
                deliver contributes directly to your team's success, making each
                effort truly impactful!
              </div> */}
              <div className="content_div_heading">
                {" "}
                Great Venues, Great Vibes{" "}
              </div>
              <div className="content_div_text">
                Play in high-quality venues designed to enhance your experience
                and keep the energy high!
              </div>
            </div>
          </div>
        </div>
        {/* play */}
        {/* <div className='item'>
          <div className='slider_card'>
            <div className='slider_img_div'>
              <img src={slide_img_new6} alt='img' />
            </div>
            <div className='slider_content'>
              <div className='content_div_heading'>Play in Style</div>
              <div className='content_div_text'>
                Compete in state-of-the-art venues that enhance your tournament experience and let your skills shine!
              </div>
            </div>
          </div>
        </div> */}
      </OwlCarousel>
    </div>
  );
};

export default MyCarousel;
